document.addEventListener("DOMContentLoaded", () => {

  // ===============================
  // Helpers
  // ===============================
  function getVal(name) {
    const el = document.querySelector(`[name="${name}"]`);
    if (!el) return null;
    const v = el.value;
    if (v === "" || v === null || typeof v === "undefined") return null;
    const n = Number(v);
    return isNaN(n) ? null : n;
  }

  function clearAllErrors() {
    document.querySelectorAll(".prescription-field-group").forEach(g => {
      g.classList.remove("has-error");
      const err = g.querySelector(".field-error");
      if (err) err.remove();
    });
  }

  function showFieldError(inputEl, message) {
    if (!inputEl) return;
    const group = inputEl.closest(".prescription-field-group");
    if (!group) return;

    group.classList.add("has-error");

    let err = group.querySelector(".field-error");
    if (!err) {
      err = document.createElement("div");
      err.className = "field-error";
      err.style.color = "rgb(255,77,79)";
      err.style.fontSize = "12px";
      err.style.marginTop = "4px";
      group.appendChild(err);
    }
    err.textContent = message;
  }

  function getMetafieldNumber(key, fallback) {
    const el = document.querySelector(`[data-metafield="${key}"]`);
    if (!el) return fallback;
    const n = Number(el.dataset.value);
    return isNaN(n) ? fallback : n;
  }

  // ===============================
  // Variant auto lock by CYL
  // ===============================
  function getSelectedCYL() {
    const r = getVal("properties[CYL Right]");
    const l = getVal("properties[CYL Left]");
    return Math.max(r || 0, l || 0);
  }

  function lockVariantByCYL() {
    const maxCyl = getSelectedCYL();

    const variantRadios = document.querySelectorAll('input[type="radio"][name^="CYL Range"], input[type="radio"][name*="CYL"]');
    if (!variantRadios.length) return;

    let smallVariant = null;
    let bigVariant = null;

    variantRadios.forEach(r => {
      const label = document.querySelector(`label[for="${r.id}"]`);
      if (!label) return;
      const text = label.textContent || "";
      if (text.includes("0.00") || text.includes("0 - 2") || text.includes("0.00 – 2.00")) {
        smallVariant = r;
      } else {
        bigVariant = r;
      }
    });

    if (!smallVariant || !bigVariant) return;

    if (maxCyl > 2) {
      if (!bigVariant.checked) bigVariant.click();
    } else {
      if (!smallVariant.checked) smallVariant.click();
    }
  }

  // ===============================
  // PD Mode Lock (Single vs Dual)
  // ===============================
  const pdSingleInput = document.querySelector('[name="properties[PD]"]');
  const pdRightInput  = document.querySelector('[name="properties[PD Right]"]');
  const pdLeftInput   = document.querySelector('[name="properties[PD Left]"]');

  const pdTypeSingleRadio = document.querySelector('input[type="radio"][name="pd_type"][value="single"]');
  const pdTypeDualRadio   = document.querySelector('input[type="radio"][name="pd_type"][value="dual"]');

  function setPDMode(mode) {
    if (!pdSingleInput || !pdRightInput || !pdLeftInput) return;

    if (mode === "single") {
      pdSingleInput.disabled = false;

      pdRightInput.disabled = true;
      pdLeftInput.disabled = true;

      pdRightInput.value = "";
      pdLeftInput.value = "";
    } else if (mode === "dual") {
      pdSingleInput.disabled = true;
      pdSingleInput.value = "";

      pdRightInput.disabled = false;
      pdLeftInput.disabled = false;
    }

    if (typeof window.validatePrescription === "function") {
      window.validatePrescription();
    }
  }

  if (pdTypeSingleRadio) {
    pdTypeSingleRadio.addEventListener("change", () => {
      if (pdTypeSingleRadio.checked) setPDMode("single");
    });
  }

  if (pdTypeDualRadio) {
    pdTypeDualRadio.addEventListener("change", () => {
      if (pdTypeDualRadio.checked) setPDMode("dual");
    });
  }

  // ===============================
  // Validation Core
  // ===============================
  window.validatePrescription = function () {
    clearAllErrors();

    const pdSingle = getVal("properties[PD]");
    const pdRight  = getVal("properties[PD Right]");
    const pdLeft   = getVal("properties[PD Left]");

    const axisRight = getVal("properties[AXIS Right]");
    const axisLeft  = getVal("properties[AXIS Left]");

    const singleRadio = document.querySelector('input[name="pd_type"][value="single"]');
    const dualRadio   = document.querySelector('input[name="pd_type"][value="dual"]');

    const isSingleMode = singleRadio && singleRadio.checked;
    const isDualMode   = dualRadio && dualRadio.checked;

    const PD_SINGLE_MIN = getMetafieldNumber("PD_MIN", 48);
    const PD_SINGLE_MAX = getMetafieldNumber("PD_MAX", 80);
    const PD_DUAL_MIN   = getMetafieldNumber("PD_DUAL_MIN", 24);
    const PD_DUAL_MAX   = getMetafieldNumber("PD_DUAL_MAX", 40);

    const AXIS_MIN = getMetafieldNumber("AXIS_MIN", 0);
    const AXIS_MAX = getMetafieldNumber("AXIS_MAX", 180);

    let ok = true;

    // PD mode consistency
    if (isSingleMode) {
      if (pdRight !== null || pdLeft !== null) {
        showFieldError(pdRightInput, "Στο Single PD δεν συμπληρώνεις PD Right / Left.");
        showFieldError(pdLeftInput, "Στο Single PD δεν συμπληρώνεις PD Right / Left.");
        ok = false;
      }
      if (pdSingle === null) {
        showFieldError(pdSingleInput, "Συμπλήρωσε το PD (Single).");
        ok = false;
      } else if (pdSingle < PD_SINGLE_MIN || pdSingle > PD_SINGLE_MAX) {
        showFieldError(pdSingleInput, `Το PD (Single) πρέπει να είναι μεταξύ ${PD_SINGLE_MIN} και ${PD_SINGLE_MAX}.`);
        ok = false;
      }
    }

    if (isDualMode) {
      if (pdRight === null) {
        showFieldError(pdRightInput, "Συμπλήρωσε PD Right.");
        ok = false;
      } else if (pdRight < PD_DUAL_MIN || pdRight > PD_DUAL_MAX) {
        showFieldError(pdRightInput, `Το PD Right πρέπει να είναι μεταξύ ${PD_DUAL_MIN} και ${PD_DUAL_MAX}.`);
        ok = false;
      }

      if (pdLeft === null) {
        showFieldError(pdLeftInput, "Συμπλήρωσε PD Left.");
        ok = false;
      } else if (pdLeft < PD_DUAL_MIN || pdLeft > PD_DUAL_MAX) {
        showFieldError(pdLeftInput, `Το PD Left πρέπει να είναι μεταξύ ${PD_DUAL_MIN} και ${PD_DUAL_MAX}.`);
        ok = false;
      }
    }

    // AXIS validation
    const axisRightEl = document.querySelector('[name="properties[AXIS Right]"]');
    const axisLeftEl  = document.querySelector('[name="properties[AXIS Left]"]');

    if (axisRight !== null && (axisRight < AXIS_MIN || axisRight > AXIS_MAX)) {
      showFieldError(axisRightEl, `Το AXIS Right πρέπει να είναι μεταξύ ${AXIS_MIN} και ${AXIS_MAX}.`);
      ok = false;
    }

    if (axisLeft !== null && (axisLeft < AXIS_MIN || axisLeft > AXIS_MAX)) {
      showFieldError(axisLeftEl, `Το AXIS Left πρέπει να είναι μεταξύ ${AXIS_MIN} και ${AXIS_MAX}.`);
      ok = false;
    }

    return ok;
  };

  // ===============================
  // Bind events
  // ===============================
  const watchNames = [
    "properties[PD]",
    "properties[PD Right]",
    "properties[PD Left]",
    "properties[AXIS Right]",
    "properties[AXIS Left]",
    "properties[CYL Right]",
    "properties[CYL Left]"
  ];

  watchNames.forEach(name => {
    const el = document.querySelector(`[name="${name}"]`);
    if (el) {
      el.addEventListener("change", () => {
        lockVariantByCYL();
        window.validatePrescription();
      });
      el.addEventListener("input", () => {
        lockVariantByCYL();
        window.validatePrescription();
      });
    }
  });

  const radios = document.querySelectorAll('input[name="pd_type"]');
  radios.forEach(r => r.addEventListener("change", () => window.validatePrescription()));

  // ===============================
  // Block submit if invalid
  // ===============================
  const form = document.querySelector("form[action*='/cart/add']");
  if (form) {
    form.addEventListener("submit", (e) => {
      if (!window.validatePrescription()) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }

  // Init
  if (pdTypeSingleRadio && pdTypeSingleRadio.checked) setPDMode("single");
  if (pdTypeDualRadio && pdTypeDualRadio.checked) setPDMode("dual");

  lockVariantByCYL();
  window.validatePrescription();

});
